import { UseQueryOptions } from '@tanstack/react-query';
import useAppQuery from 'hooks/useAppQuery';
import { GetAllAgentsResponseTO } from 'models/Agents';
import API from 'services/API';

export const THIRD_PARTY_AGENCIES_BASE_QUERY_KEY = 'third-party-agencies';

type ReactQueryOptions = Omit<
  UseQueryOptions<GetAllAgentsResponseTO>,
  'queryKey' | 'queryFn'
>;

type UseFetchThirdPartyAgenciesArgs = ReactQueryOptions;

const useFetchThirdPartyAgencies = ({
  enabled = true,
  ...options
}: UseFetchThirdPartyAgenciesArgs = {}) => {
  return useAppQuery<GetAllAgentsResponseTO>({
    queryKey: [THIRD_PARTY_AGENCIES_BASE_QUERY_KEY, 'list'],
    queryFn: async () => {
      const response = await API.get<GetAllAgentsResponseTO>('/v3/agents');

      return response.data;
    },
    enabled,
    staleTime: 30000,
    keepPreviousData: true,
    ...options,
  });
};

export default useFetchThirdPartyAgencies;
